import { defineMessages } from "react-intl"

export const messages = defineMessages({
    selectionLabel: {
        id: "terminal-payment.selection-label",
        defaultMessage: "Select Terminal",
    },
    noAvailableTerminals: {
        id: "terminal-payment.no-available-terminals",
        defaultMessage: "No available terminals.",
    },
    inUse: {
        id: "terminal-payment.in-use",
        defaultMessage: "IN USE",
    },
})


// WEBPACK FOOTER //
// ./src/common/terminal-payment/messages.ts